// removed by extract-text-webpack-plugin
module.exports = {"card":"styles--card--CgEhfnBY","save-button":"styles--save-button--2VJ14gOF","saveButton":"styles--save-button--2VJ14gOF"};


//////////////////
// WEBPACK FOOTER
// ./src/App/account/components/GetInvolvedPage/styles.css
// module id = 1245
// module chunks = 2